import React from "react";
import Carousel from "../Carousel/Carousel";
import "../../LandingPage/LandingPage.css";
import "../../LogIn/LogIn.css";
import image1 from "../../LandingPage/img/imagen1.jpg";
import image2 from "../../LandingPage/img/imagen2.jpg";
import image3 from "../../LandingPage/img/imagen3.jpg";
import image4 from "../../LandingPage/img/imagen4.jpg";
import image5 from "../../LandingPage/img/imagen5.jpg";
import image6 from "../../LandingPage/img/imagen6.jpg";

// Reuses the same carousel background as the LogIn page (LandingPage.jsx)
// so standalone auth pages (forgot/reset password) look consistent with it.
function AuthPageBackground({ children }) {
  return (
    <div className="landing-page-container auth-page-background">
      <div className="landing-page-carousel">
        <Carousel
          Images={[image1, image2, image3, image4, image5, image6]}
          timeSlideInSeconds={5}
          controls={false}
        />
        <div className="landing-page-carousel-bottom-gradient" />
      </div>
      <div className="auth-page-card">{children}</div>
    </div>
  );
}

export default AuthPageBackground;
